export default __webpack_public_path__ + "static/support-het-vrije-geluid-0d4dfd14c61f839f524e2ddd130d8b76.png";